import { LuHome, LuPackage, LuSearch, LuShoppingCart, LuUser } from "react-icons/lu";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import { selectCartCount } from "../../Redux/reducer/cartReducer";
import { ORDERING_ENABLED } from "../../config/features";
import { useCiT } from "../../common/ci/i18n";

/**
 * Mobile bottom nav — canvas ke hisaab se 5 tab:
 * Home · Search · Cart · Orders · Account. 44px se bade touch target.
 * Orders: login ho to My Orders, warna public order tracking.
 */
export const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const current = location.pathname;
  const userDetails = useSelector(
    (state: RootState) => state.Login.ContractorData
  );
  const cartCount = useSelector(selectCartCount);
  const t = useCiT();

  const items: {
    path: string;
    label: string;
    icon: JSX.Element;
    match: (p: string) => boolean;
    show?: boolean;
    badge?: number;
  }[] = [
    {
      path: "/",
      label: "Home",
      icon: <LuHome size={22} />,
      match: (p) => p === "/",
    },
    {
      path: "/searchpage",
      label: "Search",
      icon: <LuSearch size={22} />,
      match: (p) => p === "/searchpage" || p.startsWith("/items") || p.startsWith("/c/") || p === "/categories",
    },
    {
      path: "/cart",
      label: "Cart",
      icon: <LuShoppingCart size={22} />,
      match: (p) => p === "/cart" || p === "/checkout",
      show: ORDERING_ENABLED,
      badge: cartCount,
    },
    {
      path: userDetails ? "/profile/my-orders" : "/order",
      label: "Orders",
      icon: <LuPackage size={22} />,
      match: (p) =>
        p === "/profile/my-orders" || p === "/order" || p.startsWith("/tracking") || p.startsWith("/order-placed"),
    },
    {
      path: userDetails ? "/profile" : "/signup",
      label: userDetails ? "Account" : "Login",
      icon: <LuUser size={22} />,
      match: (p) => (p.startsWith("/profile") && p !== "/profile/my-orders") || p === "/signup",
    },
  ];

  return (
    <nav
      aria-label="Bottom navigation"
      className="sticky bottom-0 left-0 right-0 z-30 flex border-t border-ci-line bg-white pb-[env(safe-area-inset-bottom)] sm:hidden"
    >
      {items
        .filter((it) => it.show === undefined || it.show)
        .map((it) => {
          const active = it.match(current);
          return (
            <button
              key={it.label}
              type="button"
              onClick={() => navigate(it.path)}
              aria-current={active ? "page" : undefined}
              className={`flex h-[58px] flex-1 flex-col items-center justify-center gap-[3px] text-[11px] font-semibold ${
                active ? "text-ci-orange" : "text-ci-muted"
              }`}
            >
              <span className="relative">
                {it.icon}
                {it.badge && it.badge > 0 ? (
                  <span className="absolute -right-2.5 -top-2 flex h-[17px] min-w-[17px] items-center justify-center rounded-full bg-ci-orange px-1 text-[10px] font-bold text-white">
                    {it.badge > 99 ? "99+" : it.badge}
                  </span>
                ) : null}
              </span>
              {t(it.label)}
            </button>
          );
        })}
    </nav>
  );
};
